// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--9d2e5";
export var resultContent = "listResults-module--result-content--e637c";
export var resultItem = "listResults-module--result-item--9be35";
export var resultResume = "listResults-module--result-resume--a1a40";
export var resultTitle = "listResults-module--result-title--adb48";
export var resultType = "listResults-module--result-type--9a38d";
export var resultTypeIcon = "listResults-module--result-type-icon--ec1eb";
export var resultTypeType = "listResults-module--result-type-type--75648";
export var results = "listResults-module--results--9b62c";
export var resultsContainer = "listResults-module--results-container--bd9d0";
export var resultsTop = "listResults-module--results-top--68927";